export const STORAGE_KEY = `lekoarts-themes`
export const THEMES = [`light`, `dark`] as const
export const DEFAULT_THEME = `system`
